import _ from "underscore";

import { 
	SET_AGGREGATION_LEVEL, 
	SET_AGGREGATION_LEVEL_LEFT, 
	SET_AGGREGATION_LEVEL_RIGHT,
	SET_TIMESERIES_EXPANDED,
	SET_TIMESERIES_EXPANDED_LEFT,
	SET_TIMESERIES_EXPANDED_RIGHT,
	SET_TIMESERIES_SHRUNK,
	SET_TIMESERIES_SHRUNK_LEFT,
	SET_TIMESERIES_SHRUNK_RIGHT,
} from "actions/constants.js";

import { addConfigFilters } from "lib/helpers/filterHelpers.js";
import { fetchAltNarrativesForCrosstabs, fetchEntities, fetchTimeseries, fetchArticlesInit, fetchMapData } from "actions/fetch";
import { varStoreUpdate } from "actions/data.js";
import { clearIndicator } from "actions/ui.js";
import { clearIndicatorLeft } from "actions/ui-left.js";
import { clearIndicatorRight } from "actions/ui-right.js";
import { reactivateFilters } from "lib/helpers/filterHelpers.js";

// import mockAPI from "lib/mockData/mockAPI.js";

// ---------------- Redux Actions -------------------

// Initial timeseries fetch on load (only)
export function fetchTimeseriesInit(baseNarrativeObject, perspective, getBaseTimeseries) {
	// NOTE: To remove the baseNarrativeObject, pass this the children in an array. varStoreUpdate still needs baseNarrativeObject
	//		see commit 42da94d7aa594627e7b37c7d47165993d0176c35 (but don't copy it - other parts don't work with the current structure)
	const allNarratives = _.filter(baseNarrativeObject.children, (narrative) => {
		return narrative.parent === "narratives";
	});
	if (getBaseTimeseries) {
		allNarratives.push(baseNarrativeObject);
	}

	if (!allNarratives || allNarratives.length <= 0) {
		console.error("fetchTimeseriesInit - allNarratives are missing", allNarratives);
	}

	return (dispatch, getState) => {
		const { altProjectForCrosstabsNarratives, projectMapConfig, showAllTopicsMap } = getState().projectConfig;
		const configStateFilter = projectMapConfig && projectMapConfig.narratives && projectMapConfig.narratives.state;
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const { dmaAggregation, relevancy } = getState().base;
		const filtersList = configStateFilter ? addConfigFilters([], configStateFilter, baseFilters) : [];
		const allFilters = configStateFilter ? reactivateFilters(baseFilters, filtersList) : baseFilters;

		dispatch({
			type: "requestTimeseries",
			numberOfLines: allNarratives.length,
			narrativesArray: allNarratives,
		});
		dispatch(
			varStoreUpdate({
				nar: baseNarrativeObject,
				perspective,
				activeFilters: filtersList,
			})
		);

		if (altProjectForCrosstabsNarratives) {
			dispatch(fetchAltNarrativesForCrosstabs(altProjectForCrosstabsNarratives));
		}
		// dispatch entities fetch, but only once
		// 		have to wait for the date range to fetch entities
		dispatch(
			fetchTimeseries({
				narrative: allNarratives[0],
				perspective,
				filtersList,
				currentFilters: allFilters,
				relevancy,
			})
		)
			.then((json) => {
				// --------- Make timeseries dependant requests here -------
				const timeseriesKeys = Object.keys(json.data.timeseries);
				const startDate = Number(timeseriesKeys[0]);
				const endDate = Number(timeseriesKeys[timeseriesKeys.length - 1]);
				if (showAllTopicsMap) {
					// Calling this outside of data.js to prevent a fetchKey mismatch
					dispatch(
						fetchMapData({
							narrative: {
								id: "narratives",
								parent: "self",
								color: { dark: "#accaf2", light: "#7c8faf" },
							},
							perspective: "Source",
							startDate,
							endDate,
							filtersList: [],
							currentFilters: [],
							relevancy,
							stateCode: undefined, // false causes an error
							dmaAggregation,
							fetchKey: undefined, // false causes an error
							currentMapSegmentSpan: { name: "1 week", id: 7 },
						})
					);
				}
				dispatch(
					fetchArticlesInit({
						narratives: baseNarrativeObject.children,
						startDate,
						endDate,
						relevancy,
					})
				);
				dispatch(
					fetchEntities({
						narrative: "narratives",
						perspective,
						startDate,
						endDate,
						filtersList,
						relevancy,
						// translateEntities, //  NOTE: Install this
					})
				);
			})
			.catch((error) => {
				console.error(error);
			});
		// Get the rest of the timerseries
		// NOTE: starts with 1
		for (let i = 1; i < allNarratives.length; i++) {
			dispatch(
				fetchTimeseries({
					narrative: allNarratives[i],
					perspective,
					filtersList,
					currentFilters: allFilters,
					relevancy,
				})
			);
		}
	};
}

export const setAggregationLevel = (params) => {
	const { level } = params;
	return (dispatch, getState) => {
		dispatch({
			type: SET_AGGREGATION_LEVEL,
			level,
		});
	};
};

export const setAggregationLevelLeft = (params) => {
	const { level } = params;
	return (dispatch, getState) => {
		dispatch({
			type: SET_AGGREGATION_LEVEL_LEFT,
			level,
		});
	};
};

export const setAggregationLevelRight = (params) => {
	const { level } = params;
	return (dispatch, getState) => {
		dispatch({
			type: SET_AGGREGATION_LEVEL_RIGHT,
			level,
		});
	};
};

// // Handles the recieving a new timeseries (not baseline).
// //   Decides if it requires zooming the scale.
// // TODO: This will need to be rewritten to reflect an updated API
// export function addTimeseries(json, trendMeta, rigged, maxYValue) {
// 	const trend = {
// 		id: trendMeta.id,
// 		name: trendMeta.name,
// 		query: trendMeta.query,
// 		color: trendMeta.color,
// 	};
// 	const possibleTimeseries = json[rigged.id];

// 	// Pull correct timeseries
// 	const childTrend = possibleTimeseries[trend.id];
// 	trend.timeseries = childTrend || possibleTimeseries.Overall;

// 	// get date range
// 	const keys = _.keys(trend.timeseries);
// 	trend.rangeStart = Math.min(...keys);
// 	trend.rangeEnd = Math.max(...keys);

// 	const newY = findY(trend.timeseries);
// 	const needsAnimationDelay = maxYValue < newY;
// 	return (dispatch) => {
// 		if (needsAnimationDelay) {
// 			dispatch(animateTrendIn(newY));
// 			setTimeout(() => {
// 				dispatch(addTrendNow(trend, newY));
// 			}, 800);
// 		} else {
// 			dispatch(addTrendNow(trend, newY));
// 		}
// 	};
// }

// // Actually adds the trend line
// export function addTrendNow(trend, newY) {
// 	return {
// 		type: "addTrend",
// 		trend,
// 		newY,
// 	};
// }
// Actually adds the trend line

// TODO: this needs to be rewritten once deleting trends is supported - it worked before the Graph rewrite
//		It needs to remove trends from activeTrends - that's about it. (probably affects filters too)
// // Decides if deleting a trend line should trigger an animation
// export function deleteTrend(trend, maxYValue) {
// 	return (dispatch) => {
// 		const trendMaxY = findY(trend.timeseries);
// 		const needsAnimationDelay = trendMaxY >= maxYValue - 10; // just in case rounding gets weird
// 		if (needsAnimationDelay) {
// 			dispatch({ type: "deleteTrend", trend });
// 			dispatch({ type: "animateTrendOut", trend });
// 			setTimeout(() => {
// 				dispatch({ type: "resetGraph" });
// 			}, 800);
// 		} else {
// 			dispatch({ type: "deleteTrend", trend });
// 		}
// 	};
// }

export const setTimeSeriesExpanded = (expanded) => {
	return { type: SET_TIMESERIES_EXPANDED, expanded };
}
export const setTimeSeriesExpandedLeft = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_TIMESERIES_EXPANDED_LEFT, expanded });
		dispatch({ type: SET_TIMESERIES_EXPANDED_RIGHT, expanded });
	}
}
export const setTimeSeriesExpandedRight = (expanded) => {
	return (dispatch) => {
		dispatch({ type: SET_TIMESERIES_EXPANDED_LEFT, expanded });
		dispatch({ type: SET_TIMESERIES_EXPANDED_RIGHT, expanded });
	}
}

export const setTimeSeriesShrunk = (shrunk) => {
	return { type: SET_TIMESERIES_SHRUNK, shrunk };
}
export const setTimeSeriesShrunkLeft = (shrunk) => {
	return { type: SET_TIMESERIES_SHRUNK_LEFT, shrunk };
}
export const setTimeSeriesShrunkRight = (shrunk) => {
	return { type: SET_TIMESERIES_SHRUNK_RIGHT, shrunk };
}